import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';

function useFabricBySlug() {
  const [fabricsData, setFabricsData] = useState(null);
  const match = useRouteMatch();
  const { loading, error, data } = useQuery(FABRICS_BY_SLUG, {
    variables: {
      slug: match.params.slug
    }
  });

  useEffect(() => {
    if (!loading) {
      setFabricsData(data);
    }
  }, [match.params.slug, loading]);

  return { loading, error, data: fabricsData };
}

export default useFabricBySlug;

export const FABRICS_BY_SLUG = gql`
  query fabricsBySlug($slug: String!) {
    productBySlug(slug: $slug) {
      sku
      slug
      preferred_pdp_fabrics: pdp_fabrics(preferred: true) {
        ...PDPFabricFields
      }
      non_preferred_pdp_fabrics: pdp_fabrics(preferred: false) {
        ...PDPFabricFields
      }
      pdp_fabrics {
        ...PDPFabricFields
      }
    }
  }

  fragment PDPFabricFields on Fabric {
    id
    is_available_on_pdp
    name
    description
    is_product_sold_out
    is_kid
    popular_ranking
    image
    collaborator {
      id
      name
    }
    colors {
      id
      name
      hex_code
    }
    pattern {
      id
      name
    }
    material {
      id
      name
      composition
      durability
    }
  }
`;
